/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IGlucoUser } from 'app/shared/model/gluco-user.model';

export interface IGynaecHistory {
  id?: string;
  lmp?: number;
  menarche?: string | null;
  periodRegular?: number;
  periodCycleInterval?: number;
  parity?: number | null;
  loss?: string | null;
  pain?: string | null;
  vaginalDischarge?: string | null;
  endOfMenopause?: number | null;
  imb?: boolean | null;
  papSmear?: boolean | null;
  papSmearResult?: string | null;
  papSmearDate?: number | null;
  infertilityHist?: boolean | null;
  breastFeeding?: boolean | null;
  historyOfDES?: boolean | null;
  desObservation?: string | null;
  desDate?: number | null;
  sbe?: boolean | null;
  sbeObsv?: string | null;
  sbeDate?: number | null;
  momogram?: boolean | null;
  momogramObsv?: string | null;
  mamogramDate?: number | null;
  active?: boolean | null;
  draft?: boolean;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  patient?: IGlucoUser | null;
}

export const defaultValue: Readonly<IGynaecHistory> = {
  imb: false,
  papSmear: false,
  infertilityHist: false,
  breastFeeding: false,
  historyOfDES: false,
  sbe: false,
  momogram: false,
  active: false,
  draft: false,
};
